/**
 * useOrders
 * The custom hook which provided to external use via context
 */

import { useContext } from 'react'

import OrdersContext from './orders-context'

const useOrders = () => {
  const context = useContext(OrdersContext)
  return context
}

export default useOrders
